import { Box } from "@chakra-ui/react";
import { createApplication, listUnappliedBatches } from "../../../api/utils/api";

import CardsLayout from "../../../components/common/layouts/CardsLayout";
import { useCallback, useContext, useEffect, useState } from "react";
import { GetBatch } from "../../../api/schemas/schema";
import { AppContext } from "../../../context/ApplicationContext";
import { useHistory } from "react-router-dom";

import { useDebouncedCallback } from "use-debounce";
import useSnackBar from "../../../components/common/general/SnackBar";
import { axiosErrorHandler } from "../../../api/utils/error";
import ScholarMasaiXCourseCard from "../../Courses/NewCoursesFlow/ScholarProgram/ScholarMasaiXCourseCard";
import { isCourseProgramsIntersectsProfilePrograms } from "../../../components/common/utils/isProgramPresent";

const CoursesFailPage = () => {
  const [courses, setCourses] = useState<GetBatch[]>([]);
  const state = useContext(AppContext)[0];
  const [loading, setLoading] = useState<boolean>(false);
  const snackbar = useSnackBar();
  const history = useHistory();
  useEffect(() => {
    fetchInfo();
  }, [state.profileData?.slug]);

  const fetchInfo = useCallback(async () => {
    setLoading(true);
    if (state.profileData?.slug) {
      try {
        const res = await Promise.allSettled([
          listUnappliedBatches({ profile_slug: state.profileData.slug }).then((res) => {
            setCourses(res);
          }),
        ]);
      } catch (err) {
        const e = axiosErrorHandler(err);
        if (typeof e === "object" && "message" in e) {
          snackbar.error(e.message);
        } else {
          snackbar.error("something went wrong");
        }
      }

      setLoading(false);
    }
  }, [state.profileData?.slug]);

  const handleCreateApplication = useDebouncedCallback(
    ({ batch_campus_id }: { batch_campus_id: number }) => {
      setLoading(true);
      if (state.profileData?.slug) {
        createApplication({
          profile_slug: state.profileData.slug,
          batch_campus_id: batch_campus_id,
        })
          .then((res) => {
            setLoading(false);
            history.push(`/batch/${res.batch_campus.batch_id}/${res.slug}/applicant-details`);
            snackbar.success("Application created successfully!");
            // if not redirecting then fetch info again
            // fetchInfo();
          })
          .catch((err) => {
            const e = axiosErrorHandler(err);
            if (typeof e === "object" && "message" in e) {
              snackbar.error(e.message);
            } else {
              snackbar.error("something went wrong");
            }
            setLoading(false);
          });
      }
    },
    300
  );
  let programName = "masai_one";
  if (
    isCourseProgramsIntersectsProfilePrograms(
      state.applicationData?.batch_campus.batch?.course?.course_programs,
      [
        {
          id: 1,
          name: "Scholar",
        },
      ]
    )
  ) {
    programName = "scholar";
  } else if (
    isCourseProgramsIntersectsProfilePrograms(
      state.applicationData?.batch_campus.batch?.course?.course_programs,
      [
        {
          id: 2,
          name: "Masai_One",
        },
      ]
    )
  ) {
    programName = "masai_one";
  } else if (
    isCourseProgramsIntersectsProfilePrograms(
      state.applicationData?.batch_campus.batch?.course?.course_programs,
      [
        {
          id: 3,
          name: "MasaiX",
        },
      ]
    )
  ) {
    programName = "masaix";
  }

  return (
    <Box>
      {courses?.length > 0 && (
        <CardsLayout loading={loading} title="Recommended for you">
          {courses
            ?.filter((course) => !course.is_archived)
            .map((data) => (
              <ScholarMasaiXCourseCard key={data.id} batchData={data} />
            ))}
        </CardsLayout>
      )}
    </Box>
  );
};

export default CoursesFailPage;
